import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=1a4575e0"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=1a4575e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports